import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { SnackbarProvider, impostaTraduzione } from '@meshble/molo';

// Una sola importazione, nella radice: senza, ogni componente rende senza
// stile e col font di sistema.
import '@meshble/molo/styles.css';
import './brand.css';
import './app.css';

import { router } from './router';
import { ApiError } from './lib/api';
import { t } from './lib/lingua';

// Le frasi che i componenti del design dicono da sé — lo stato predefinito di
// un chip, il log vuoto — passano dalla stessa traduzione del pannello.
impostaTraduzione(t);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 401 e 403 non migliorano riprovando: sono risposte, non guasti.
      retry: (count, err) =>
        !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
      // Le query alimentate da SSE si duplicherebbero al rientro sulla
      // finestra: il refetch lo decide chi sa se serve, query per query.
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Uno solo, qui: gli snackbar si accodano in basso qualunque sia la
          schermata che li ha emessi. */}
      <SnackbarProvider>
        <RouterProvider router={router} />
      </SnackbarProvider>
    </QueryClientProvider>
  </StrictMode>,
);
